import { StartupQueryParameterKeys } from '../constants/App';
import { ApplicationStateKeys } from '../constants/ApplicationStateKeys';

export function get(state: $TSFixMe, key: string): $TSFixMe {
  return (
    state.application &&
    state.application.getIn([ApplicationStateKeys.STARTUP_QUERY_PARAMETERS, key])
  );
}

export function getFamilyPlanInviteToken(state: $TSFixMe): $TSFixMe {
  return get(state, StartupQueryParameterKeys.FAMILY_PLAN_INVITE_TOKEN);
}

export function getAmpSSO(state: $TSFixMe): $TSFixMe {
  return get(state, StartupQueryParameterKeys.AMP_SSO);
}

export function getERequestId(state: $TSFixMe): $TSFixMe {
  return get(state, StartupQueryParameterKeys.E_REQUEST_ID);
}

export function getStore(state: $TSFixMe): $TSFixMe {
  return get(state, StartupQueryParameterKeys.STORE);
}

export function getFeatureCode(state: $TSFixMe): $TSFixMe {
  return get(state, StartupQueryParameterKeys.FEATURE_CODE);
}

export function getEntitlementId(state: $TSFixMe): $TSFixMe {
  return get(state, StartupQueryParameterKeys.ENTITLEMENT_ID);
}

export function getRegister(state: $TSFixMe): $TSFixMe {
  return get(state, StartupQueryParameterKeys.REGISTER);
}

export function getInteractiveRadioStartupModeId(state: $TSFixMe): $TSFixMe {
  return parseInt(get(state, StartupQueryParameterKeys.MODE_ID), 10);
}

export function getToken(state: $TSFixMe): $TSFixMe {
  return get(state, StartupQueryParameterKeys.TOKEN);
}

export function getAccessToken(state: $TSFixMe): $TSFixMe {
  return get(state, StartupQueryParameterKeys.ACCESS_TOKEN);
}

// @todo GRNWEB-4689
export function getGreenfieldUpgradeFlag(state: $TSFixMe): $TSFixMe {
  return get(state, StartupQueryParameterKeys.GREENFIELD_UPGRADE_FLAG);
}
